import { render } from "./PlaceImage.vue?vue&type=template&id=f16e6a70&scoped=true"
import script from "./PlaceImage.vue?vue&type=script&lang=js"
export * from "./PlaceImage.vue?vue&type=script&lang=js"

import "./PlaceImage.vue?vue&type=style&index=0&id=f16e6a70&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16e6a70"]])

export default __exports__